// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as Aanbouw2VerdiepingenKostenRouteImport } from './routes/aanbouw-2-verdiepingen-kosten'
import { Route as AanbouwDordrechtRouteImport } from './routes/aanbouw-dordrecht'
import { Route as AanbouwKostenRouteImport } from './routes/aanbouw-kosten'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CascoAanbouwKostenRouteImport } from './routes/casco-aanbouw-kosten'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DakkapelDordrechtRouteImport } from './routes/dakkapel-dordrecht'
import { Route as DakkapelKostenRouteImport } from './routes/dakkapel-kosten'
import { Route as DienstenRouteImport } from './routes/diensten'
import { Route as KostenRouteImport } from './routes/kosten'
import { Route as KozijnenDordrechtRouteImport } from './routes/kozijnen-dordrecht'
import { Route as KozijnenKostenRouteImport } from './routes/kozijnen-kosten'
import { Route as KozijnenZwijndrechtRouteImport } from './routes/kozijnen-zwijndrecht'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OverRouteImport } from './routes/over'
import { Route as RenovatieKostenRouteImport } from './routes/renovatie-kosten'
import { Route as SchuurTuinhuisLatenBouwenRouteImport } from './routes/schuur-tuinhuis-laten-bouwen'
import { Route as SubsidieRouteImport } from './routes/subsidie'
import { Route as TimmermanDordrechtRouteImport } from './routes/timmerman-dordrecht'
import { Route as TimmermanPapendrechtRouteImport } from './routes/timmerman-papendrecht'
import { Route as TimmermanSliedrechtRouteImport } from './routes/timmerman-sliedrecht'
import { Route as TimmermanZwijndrechtRouteImport } from './routes/timmerman-zwijndrecht'
import { Route as UitbouwKostenPerM2RouteImport } from './routes/uitbouw-kosten-per-m2'
import { Route as VerbouwingDordrechtRouteImport } from './routes/verbouwing-dordrecht'
import { Route as VoorwaardenRouteImport } from './routes/voorwaarden'
import { Route as WerkInBeeldRouteImport } from './routes/werk-in-beeld'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAdminKostenRouteImport } from './routes/_authenticated/admin-kosten'
import { Route as AuthenticatedAdminSeoRouteImport } from './routes/_authenticated/admin-seo'
import { Route as DienstenSlugRouteImport } from './routes/diensten_.$slug'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const Aanbouw2VerdiepingenKostenRoute = Aanbouw2VerdiepingenKostenRouteImport.update({
            id: '/aanbouw-2-verdiepingen-kosten',path: '/aanbouw-2-verdiepingen-kosten',getParentRoute: () => rootRouteImport
          })
const AanbouwDordrechtRoute = AanbouwDordrechtRouteImport.update({
            id: '/aanbouw-dordrecht',path: '/aanbouw-dordrecht',getParentRoute: () => rootRouteImport
          })
const AanbouwKostenRoute = AanbouwKostenRouteImport.update({
            id: '/aanbouw-kosten',path: '/aanbouw-kosten',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CascoAanbouwKostenRoute = CascoAanbouwKostenRouteImport.update({
            id: '/casco-aanbouw-kosten',path: '/casco-aanbouw-kosten',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DakkapelDordrechtRoute = DakkapelDordrechtRouteImport.update({
            id: '/dakkapel-dordrecht',path: '/dakkapel-dordrecht',getParentRoute: () => rootRouteImport
          })
const DakkapelKostenRoute = DakkapelKostenRouteImport.update({
            id: '/dakkapel-kosten',path: '/dakkapel-kosten',getParentRoute: () => rootRouteImport
          })
const DienstenRoute = DienstenRouteImport.update({
            id: '/diensten',path: '/diensten',getParentRoute: () => rootRouteImport
          })
const KostenRoute = KostenRouteImport.update({
            id: '/kosten',path: '/kosten',getParentRoute: () => rootRouteImport
          })
const KozijnenDordrechtRoute = KozijnenDordrechtRouteImport.update({
            id: '/kozijnen-dordrecht',path: '/kozijnen-dordrecht',getParentRoute: () => rootRouteImport
          })
const KozijnenKostenRoute = KozijnenKostenRouteImport.update({
            id: '/kozijnen-kosten',path: '/kozijnen-kosten',getParentRoute: () => rootRouteImport
          })
const KozijnenZwijndrechtRoute = KozijnenZwijndrechtRouteImport.update({
            id: '/kozijnen-zwijndrecht',path: '/kozijnen-zwijndrecht',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const OverRoute = OverRouteImport.update({
            id: '/over',path: '/over',getParentRoute: () => rootRouteImport
          })
const RenovatieKostenRoute = RenovatieKostenRouteImport.update({
            id: '/renovatie-kosten',path: '/renovatie-kosten',getParentRoute: () => rootRouteImport
          })
const SchuurTuinhuisLatenBouwenRoute = SchuurTuinhuisLatenBouwenRouteImport.update({
            id: '/schuur-tuinhuis-laten-bouwen',path: '/schuur-tuinhuis-laten-bouwen',getParentRoute: () => rootRouteImport
          })
const SubsidieRoute = SubsidieRouteImport.update({
            id: '/subsidie',path: '/subsidie',getParentRoute: () => rootRouteImport
          })
const TimmermanDordrechtRoute = TimmermanDordrechtRouteImport.update({
            id: '/timmerman-dordrecht',path: '/timmerman-dordrecht',getParentRoute: () => rootRouteImport
          })
const TimmermanPapendrechtRoute = TimmermanPapendrechtRouteImport.update({
            id: '/timmerman-papendrecht',path: '/timmerman-papendrecht',getParentRoute: () => rootRouteImport
          })
const TimmermanSliedrechtRoute = TimmermanSliedrechtRouteImport.update({
            id: '/timmerman-sliedrecht',path: '/timmerman-sliedrecht',getParentRoute: () => rootRouteImport
          })
const TimmermanZwijndrechtRoute = TimmermanZwijndrechtRouteImport.update({
            id: '/timmerman-zwijndrecht',path: '/timmerman-zwijndrecht',getParentRoute: () => rootRouteImport
          })
const UitbouwKostenPerM2Route = UitbouwKostenPerM2RouteImport.update({
            id: '/uitbouw-kosten-per-m2',path: '/uitbouw-kosten-per-m2',getParentRoute: () => rootRouteImport
          })
const VerbouwingDordrechtRoute = VerbouwingDordrechtRouteImport.update({
            id: '/verbouwing-dordrecht',path: '/verbouwing-dordrecht',getParentRoute: () => rootRouteImport
          })
const VoorwaardenRoute = VoorwaardenRouteImport.update({
            id: '/voorwaarden',path: '/voorwaarden',getParentRoute: () => rootRouteImport
          })
const WerkInBeeldRoute = WerkInBeeldRouteImport.update({
            id: '/werk-in-beeld',path: '/werk-in-beeld',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminKostenRoute = AuthenticatedAdminKostenRouteImport.update({
            id: '/admin-kosten',path: '/admin-kosten',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminSeoRoute = AuthenticatedAdminSeoRouteImport.update({
            id: '/admin-seo',path: '/admin-seo',getParentRoute: () => AuthenticatedRouteRoute
          })
const DienstenSlugRoute = DienstenSlugRouteImport.update({
            id: '/diensten_/$slug',path: '/diensten/$slug',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedAdminKostenRoute: AuthenticatedAdminKostenRoute,AuthenticatedAdminSeoRoute: AuthenticatedAdminSeoRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,Aanbouw2VerdiepingenKostenRoute: Aanbouw2VerdiepingenKostenRoute,AanbouwDordrechtRoute: AanbouwDordrechtRoute,AanbouwKostenRoute: AanbouwKostenRoute,AuthRoute: AuthRoute,CascoAanbouwKostenRoute: CascoAanbouwKostenRoute,ContactRoute: ContactRoute,DakkapelDordrechtRoute: DakkapelDordrechtRoute,DakkapelKostenRoute: DakkapelKostenRoute,DienstenRoute: DienstenRoute,KostenRoute: KostenRoute,KozijnenDordrechtRoute: KozijnenDordrechtRoute,KozijnenKostenRoute: KozijnenKostenRoute,KozijnenZwijndrechtRoute: KozijnenZwijndrechtRoute,LoginRoute: LoginRoute,OverRoute: OverRoute,RenovatieKostenRoute: RenovatieKostenRoute,SchuurTuinhuisLatenBouwenRoute: SchuurTuinhuisLatenBouwenRoute,SubsidieRoute: SubsidieRoute,TimmermanDordrechtRoute: TimmermanDordrechtRoute,TimmermanPapendrechtRoute: TimmermanPapendrechtRoute,TimmermanSliedrechtRoute: TimmermanSliedrechtRoute,TimmermanZwijndrechtRoute: TimmermanZwijndrechtRoute,UitbouwKostenPerM2Route: UitbouwKostenPerM2Route,VerbouwingDordrechtRoute: VerbouwingDordrechtRoute,VoorwaardenRoute: VoorwaardenRoute,WerkInBeeldRoute: WerkInBeeldRoute,DienstenSlugRoute: DienstenSlugRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)